import {Column, Entity, PrimaryGeneratedColumn} from "typeorm"
import { bigint } from "../../transofrmers/BigInt";

@Entity({name: "tele2_usage_pg"})
export class Tele2PGUsage {

	@PrimaryGeneratedColumn()
	id!: number;

	@Column()
	iccid!: string;
	
	@Column()
	imsi!: string;
	
	@Column('datetime')
	timestamp!: Date;

	@Column({ nullable: true })
	network!: string

	@Column({default:false})
	online_status!: boolean

	@Column({ nullable: true, default:-1 })
	apn_id!: number

	@Column({ nullable: true, default:-1 })
	rat_id!: number

	@Column({ type: "bigint", transformer:bigint })
	upload!: number;

	@Column({ type: "bigint", transformer:bigint })
	download!: number;

	@Column({ type: "bigint", transformer:bigint })
	upload_total!: number;

	@Column({ type: "bigint", transformer:bigint })
	download_total!: number;
}